import * as Yup from "yup";

export const acadamicValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Acadamic Name is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const bankValidationSchema = Yup.object().shape({
  id: Yup.number().min(0),
  companyCode: Yup.number().min(1).required("Company Code is required"),
  bankCode: Yup.string().required("Bank code is required"),
  bankShortCode: Yup.string().required("Bank short code is required"),
  bankName: Yup.string().required("Bank Name is required"),
  swiftCode: Yup.string().required("Swift code is required"),
  accountNumber: Yup.string().required("Account Number is required"),
  organisationId: Yup.string().required("Organisation ID is required"),
  companyUEN: Yup.string().required("Company UEN is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const shiftTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  shiftTypeName: Yup.string().required("Bank Name is required"),
  // branchCode: Yup.string().required("Branch code is required"),
  // isActive: Yup.boolean().required("Please select active status"),
});

export const countryValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  country: Yup.string().required("Country Name is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const groupValidationSchema = Yup.object().shape({
  id: Yup.number(),
  companyCode: Yup.number().min(1).required("Company code is required"),
  groupCode: Yup.string().required("Group code is required"),
  groupName: Yup.string().required("Group name is required"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const raceValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Race Name is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const visaTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Visa Type Name is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const relationsShipValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const identificationValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const nationalityValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const departmentValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const designationValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const leaveTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  leaveName: Yup.string().required("Leave Name is required"),
  isActive: Yup.bool(),
});

export const additionValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Addition Name is required"),
  haveCpf: Yup.bool(),
  isTaxPayable: Yup.bool(),
});

export const deductionValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Deduction Name is required"),
  haveCpf: Yup.bool(),
  // isTaxPayable: Yup.bool(),
});

export const cpfTypeValidation = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  shortCode: Yup.string().required("shortCode is required"),
  description: Yup.string().required("userGroupCode is required"),
  isActive: Yup.bool(),
});

// Location Validation
export const locationValidation = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  locationCode: Yup.string().required("Location Code is required"),
  locationName: Yup.string().required("Location Name is required"),
  address1: Yup.string().required("Address 1  is required"),
  address2: Yup.string(),
  address3: Yup.string(),
  country: Yup.string().required("Country is required"),
  zipCode: Yup.string()
    .typeError("Zipcode is required")
    .required("Zipcode is required")
    .test(
      "zipCode",
      "Value must be 6 digits",
      (val) => val && val.toString().length === 6
    ),
  isActive: Yup.bool(),
});

export const passTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  passName: Yup.string().required("Pass Name is required"),
  isActive: Yup.bool(),
  haveSkills: Yup.bool(),
  dataFields: Yup.array().required("Please select the data fields"),
});

export const levyTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Levy Type is required"),
  isActive: Yup.bool(),
});
export const levyAmountTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  levyAmountTypeName: Yup.string().required("Levy Amount Type is required"),
  isActive: Yup.bool(),
});

export const paymodeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  paymentMode: Yup.string().required("Paymode Name is required"),
  isActive: Yup.bool(),
});

export const contractTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  contractName: Yup.string().required("Contract Name is required"),
  contractTemplate: Yup.number().required("Contract Template is required"),
  isActive: Yup.bool(),
});

export const employmentTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  termName: Yup.string().required("Term Name is required"),
  isActive: Yup.bool(),
});

export const employeeWorkTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  description: Yup.string().required("Employee Work Type is required"),
  isActive: Yup.bool(),
});

export const employeeTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  typeName: Yup.string().required("Employee Type is required"),
  isActive: Yup.bool(),
});

export const workingDayTypeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  typeName: Yup.string().required("Working Day Type is required"),
  isActive: Yup.bool(),
});

export const employeeStatusValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  statusName: Yup.string().required("Status Name is required"),
  isActive: Yup.bool(),
});

// export const cpfContributionRateValidation = Yup.object().shape({
//   cpfContributionRates: Yup.array().of(
//     Yup.object().shape({
//       contributionCode: Yup.number().required("Contribution Code is required"),
//       rangeFrom: Yup.number()
//         .typeError("Range From must be a number")
//         .required("Range From is required"),
//       rangeTo: Yup.number()
//         .typeError("Range To must be a number")
//         .required("Range To is required"),
//       amount: Yup.number()
//         .typeError("Amount must be a number")
//         .required("Amount is required"),
//       isActive: Yup.bool(),
//     })
//   ),
// });

export const cpfContributionRateValidation = Yup.object().shape({
  contributionCode: Yup.number().required("Contribution Code is required"),
  rangeFrom: Yup.number()
    .typeError("Range From must be a number")
    .required("Range From is required"),
  rangeTo: Yup.number()
    .typeError("Range To must be a number")
    .required("Range To is required"),
  amount: Yup.number()
    .typeError("Amount must be a number")
    .required("Amount is required"),
  isActive: Yup.bool(),
});

export const cpfPercentageValidation = Yup.object().shape({
  // cpfPercentage: Yup.array().of(
  //   Yup.object().shape({
  cpftype: Yup.string().required("Contribution Code is required"),
  ageFrom: Yup.number()
    .typeError("Age From must be a number")
    .required("Age From is required"),
  ageTo: Yup.number()
    .typeError("Age To must be a number")
    .required("Age To is required"),

  // salaryFrom: Yup.number()
  //   .typeError("Salary From must be a number")
  //   .required("Salary From is required"),
  // salaryTo: Yup.number()
  //   .typeError("Salary To must be a number")
  //   .required("Salary To is required"),
  employeePercentage: Yup.number()
    .typeError("Employee Percentage must be a number")
    .required("Employee Percentage is required"),
  employerPercentage: Yup.number()
    .typeError("Employee Percentage must be a number")
    .required("Employer Percentage is required"),
  totalPercentage: Yup.number()
    .typeError("Total Percentage must be a number")
    .required("Total Percentage is required"),
  employeeCpfMaxCeiling: Yup.number()
    .typeError("Employee Cpf Max Ceiling must be a number")
    .required("Employee Cpf Max Ceiling is required"),
  totalCpfMaxCeiling: Yup.number()
    .typeError("Total Cpf Max Ceiling must be a number")
    .required("Total Cpf Max Ceiling is required"),
  isActive: Yup.bool(),
  //   })
  // ),
});

export const addMultiCpfPercentageValidation = Yup.object().shape({
  cpfPercentage: Yup.array().of(
    Yup.object().shape({
      cpftype: Yup.string().required("Contribution Code is required"),
      ageFrom: Yup.number()
        .typeError("Age From must be a number")
        .required("Age From is required"),
      ageTo: Yup.number()
        .typeError("Age To must be a number")
        .required("Age To is required"),

      // salaryFrom: Yup.number()
      //   .typeError("Salary From must be a number")
      //   .required("Salary From is required"),
      // salaryTo: Yup.number()
      //   .typeError("Salary To must be a number")
      //   .required("Salary To is required"),
      employeePercentage: Yup.number()
        .typeError("Employee Percentage must be a number")
        .required("Employee Percentage is required"),
      employerPercentage: Yup.number()
        .typeError("Employee Percentage must be a number")
        .required("Employer Percentage is required"),
      totalPercentage: Yup.number()
        .typeError("Total Percentage must be a number")
        .required("Total Percentage is required"),
      employeeCpfMaxCeiling: Yup.number()
        .typeError("Employee Cpf Max Ceiling must be a number")
        .required("Employee Cpf Max Ceiling is required"),
      totalCpfMaxCeiling: Yup.number()
        .typeError("Total Cpf Max Ceiling must be a number")
        .required("Total Cpf Max Ceiling is required"),
      isActive: Yup.bool(),
    })
  ),
});

export const cpfPercentageFLIValidation = Yup.object().shape({
  // cpfPercentageFLI: Yup.array().of(
  //   Yup.object().shape({
  cpftype: Yup.string().required("Contribution Code is required"),
  ageFrom: Yup.number()
    .typeError("Age From must be a number")
    .required("Age From is required"),
  ageTo: Yup.number()
    .typeError("Age To must be a number")
    .required("Age To is required"),

  salaryFrom: Yup.number()
    .typeError("Salary From must be a number")
    .required("Salary From is required"),
  salaryTo: Yup.number()
    .typeError("Salary To must be a number")
    .required("Salary To is required"),
  employeePercentage: Yup.number()
    .typeError("Employee Percentage must be a number")
    .required("Employee Percentage is required"),
  employerPercentage: Yup.number()
    .typeError("Employee Percentage must be a number")
    .required("Employer Percentage is required"),
  // totalPercentage: Yup.number()
  //   .typeError("Total Percentage must be a number")
  //   .required("Total Percentage is required"),
  // employeeCpfMaxCeiling: Yup.number()
  //   .typeError("Employee Cpf Max Ceiling must be a number")
  //   .required("Employee Cpf Max Ceiling is required"),
  employeePercentageSalaryCeiling: Yup.number()
    .typeError("Employee Percentage Salary Ceiling must be a number")
    .required("Employee Percentage Salary Ceiling is required"),
  // totalCpfMaxCeiling: Yup.number()
  //   .typeError("Total Cpf Max Ceiling must be a number")
  //   .required("Total Cpf Max Ceiling is required"),
  isActive: Yup.bool(),
  //   })
  // ),
});

export const addMultiCpfPercentageFLIValidation = Yup.object().shape({
  cpfPercentage: Yup.array().of(
    Yup.object().shape({
      cpftype: Yup.string().required("Contribution Code is required"),
      ageFrom: Yup.number()
        .typeError("Age From must be a number")
        .required("Age From is required"),
      ageTo: Yup.number()
        .typeError("Age To must be a number")
        .required("Age To is required"),

      salaryFrom: Yup.number()
        .min(1, "Salary From Must be greater than 1")
        .typeError("Salary From must be a number")
        .required("Salary From is required"),
      salaryTo: Yup.number()
        .min(1, "Salary From Must be greater than 1")
        .typeError("Salary To must be a number")
        .required("Salary To is required"),
      employeePercentage: Yup.number()
        .typeError("Employee Percentage must be a number")
        .required("Employee Percentage is required"),
      employerPercentage: Yup.number()
        .typeError("Employee Percentage must be a number")
        .required("Employer Percentage is required"),
      // totalPercentage: Yup.number()
      //   .typeError("Total Percentage must be a number")
      //   .required("Total Percentage is required"),
      employeePercentageSalaryCeiling: Yup.number()
        .typeError("Employee Percentage Salary Ceiling must be a number")
        .required("Employee Percentage Salary Ceiling is required"),
      // totalCpfMaxCeiling: Yup.number()
      //   .typeError("Total Cpf Max Ceiling must be a number")
      //   .required("Total Cpf Max Ceiling is required"),
      isActive: Yup.bool(),
    })
  ),
});

export const tradeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  tradeName: Yup.string().required("Trade Name is required"),
  isActive: Yup.bool().required("Please select active status"),
});

export const momTradeValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  tradeName: Yup.string().required("Mom Trade Type is required"),
  isActive: Yup.bool().required("Please select active status"),
});

export const dormitoryValidationSchema = Yup.object().shape({
  companyCode: Yup.number().min(1).required("Company Code is required"),
  dormitoryCode: Yup.number().min(0).required("Dormitory Code is required"),
  dormitoryName: Yup.string().required("Dormitory Name is required"),
  inchargeName: Yup.string().required("Incharge Name is required"),
  inchargeNumber: Yup.string().required("Incharge Number is required"),
  address: Yup.string().required("Address is required"),
  postalcode: Yup.string()
    .typeError("Postal Code must be a number")
    .required("Postal Code is required"),
  attachment: Yup.string(), // .required("Attachment is required"),
  remarks: Yup.string().required("Remarks is required"),
  isActive: Yup.bool().required("Please select active status"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),
});

export const foreignerLevyValidationSchema = Yup.object().shape({
  foreignWorkerCode: Yup.string()
    .required("Foreign Worker Code is required")
    .max(20, "Maximum 20 characters allowed"),

  description: Yup.string()
    .required("Description is required")
    .max(100, "Maximum 100 characters allowed"),

  monthlyAmount: Yup.string()
    .typeError("Monthly Amount must be a number")
    .required("Monthly Amount is required")
    .min(0, "Monthly Amount must be zero or more"),

  dailyAmount: Yup.string()
    .typeError("Daily Amount must be a number")
    .required("Daily Amount is required")
    .min(0, "Daily Amount must be zero or more"),

  isActive: Yup.boolean().required(),
});

export const vehicleAccidentValidationSchema = Yup.object().shape({
  accidentDate: Yup.string().required("Date is Required"),
  accidentLocation: Yup.string().required("Accident Location is Required"),
  driverName: Yup.string().required("Driver Name is Required"),
  driverContactNumber: Yup.string().required(
    "Driver Contact Number is Required"
  ),
  refundFromInsuranceAmount: Yup.number()
    .integer("Refund From Insurance Amount must be an integer")
    .typeError("Refund From Insurance Amount must be a number")
    .min(0, "Refund From Insurance Amount must be zero or more")
    .required("Refund From Insurance Amount is Required in vehicle accidents"),
  actualRepairingAmount: Yup.number()
    .integer("Actual Repairing Amount must be an integer")
    .typeError("Actual Repairing Amount must be a number")
    .min(0, "Actual Repairing Amount must be zero or more")
    .required("Actual Repairing Amount is Required in vehicle accidents"),

  vehicleNumber: Yup.string().required("Vehicle Number is Required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const dieselUsageValidationSchema = Yup.object().shape({
  invoiceNumber: Yup.string().required("Invoice Number is Required"),
  invoiceDate: Yup.string().required("Invoice Date is Required"),
  usageLitres: Yup.number()
    .integer("Usage Litres must be an integer")
    .typeError("Usage Litres must be a number")
    .min(0, "Usage Litres must be zero or more")
    .required("Usage Litres is Required in diesel usages"),
  amountInclGST: Yup.number()
    .integer("Amount Incl GST must be an integer")
    .typeError("Amount Incl GST must be a number")
    .min(0, "Amount Incl GST must be zero or more")
    .required("Amount Incl GST is Required in vehicle maintenances"),
  vehicleNumber: Yup.string().required("Vehicle Number is Required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const vehicleTypeValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is Required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const VehicleIndemnityValidationSchema = Yup.object().shape({
  indemnityNumber: Yup.string().required("Indemnity Number is required - 1"),
  indemnityDate: Yup.string().required("Indemnity Date is required"),
  driverName: Yup.string().required("Driver Name is required"),
  driverNRICFin: Yup.string().required("Driver NRIC/FIN is required"),
  ltA_HDB: Yup.string().required("LTA / HDB is required"),
  noticeNumber: Yup.string().required("Notice Number is required"),
  vendor: Yup.string().required("Vendor is required"),
  invoiceNumber: Yup.string().required("Invoice Number is required"),
  amount: Yup.number()
    .integer("Amount must be an integer")
    .typeError("Amount must be a number")
    .min(0, "Amount must be zero or more")
    .required("Amount is required"),
  incidentAddress: Yup.string().required("Incident Address is required"),
  issuedBy: Yup.string().required("Issued By is required"),
  designation: Yup.string().required("Designation is required"),
  issuerNRIC: Yup.string().required("Issuer NRIC is required"),
  debitStaffAmount: Yup.number()
    .integer("Debit Staff Amount must be an integer")
    .typeError("Debit Staff Amount must be a number")
    .min(0, "Debit Staff Amount must be zero or more")
    .required("Debit Staff Amount is required in vehicle indemnities"),
  writeOffAmount: Yup.number()
    .integer("Write-off Amount must be an integer")
    .typeError("Write-off Amount must be a number")
    .min(0, "Write-off Amount must be zero or more")
    .required("Write-off Amount is required in vehicle indemnities"),
  description: Yup.string().required("Description is required"),
  vehicleNumber: Yup.string().required("Vehicle Number is required"),
  isActive: Yup.boolean().required(),
});

export const vehicleMaintenanceValidationSchema = Yup.object().shape({
  invoiceNumber: Yup.string().required("Invoice Number is Required"),
  invoiceDate: Yup.string().required("Invoice Date is Required"),
  dealerName: Yup.string().required("Name is Required"),
  vehicleDescription: Yup.string().required("Name is Required"),
  amountInclGST: Yup.number()
    .integer("Amount Incl GST must be an integer")
    .typeError("Amount Incl GST must be a number")
    .min(0, "Amount Incl GST must be zero or more")
    .required("Amount Incl GST is Required in vehicle maintenances"),
  partServiced: Yup.string().required("Name is Required"),
  maintenanceNextDueDate: Yup.string().required("Invoice Date is Required"),
  lmNextDueDate: Yup.string().required("Invoice Date is Required"),
  vehicleNumber: Yup.string().required("Vehicle Number is Required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const vehicleExpensesValidationSchema = Yup.object().shape({
  vehicleNumber: Yup.string().required(),
  insuranceNumber: Yup.string().required(),
  insurancePeriod: Yup.string().required(),
  insuranceAmount: Yup.number().required(),
  insuranceVendor: Yup.string().required(),
  insuranceAgency: Yup.string().required(),
  insuranceExpiryDate: Yup.string().required(),
  craneInsuranceExpiryDate: Yup.string().required(),
  lorryCraneLMCertExpiryDate: Yup.string().required(),
  lgNextDueDate: Yup.string().required(),
  roadTaxDueDate: Yup.string().required(),
  inspectionDueDate: Yup.string().required(),
  roadTaxInspectionAmount: Yup.number().required(),
  roadTaxInvRef: Yup.string().required(),
  ncd: Yup.string().required(),
  remarks: Yup.string(),
  parkingNextDueDate: Yup.string().required(),
  vpc: Yup.string().required(),
  vpcAmount: Yup.number().required(),
  vpcAddress: Yup.string().required(),
  parkingVendor: Yup.string().required(),
  parkingLocation: Yup.string().required(),
  parkingAmount: Yup.number().required(),
  parkingCouponNextDueDate: Yup.string().required(),
  parkingAddress: Yup.string().required(),
  parkingPaymentMode: Yup.string().required(),
  fmtDueDate: Yup.string().required(),
  fmtAmount: Yup.number().required(),
  shellCardNo: Yup.string().required(),
  shellPIN: Yup.string().required(),
  isActive: Yup.boolean().required(),
});

// export const vehicleInformationValidationSchema = Yup.object().shape({
//   vehicleNumber: Yup.string().required("Vehicle Number is required"),
//   vehicleName: Yup.string().required("Vehicle Name is required"),
//   vehicleType: Yup.string().required("Vehicle Type is required"),
//   company: Yup.string().required("Company is required"),
//   department: Yup.string().required("Department is required"),
//   iuLabelNumber: Yup.string(),
//   chassisNumber: Yup.string(),
//   vehicleModel: Yup.string().required("Vehicle Model is required"),
//   vehicleCategory: Yup.string().required("Vehicle Category is required"),
//   propellant: Yup.string(),
//   status: Yup.string(),
//   assetTagNo: Yup.string(),
//   gpsSimNo: Yup.string(),
//   requireTill: Yup.string().required("Require Till is required"),
//   registerDate: Yup.string().required("Register Date is required"),
//   fine: Yup.number()
//     .typeError("Fine must be a number")
//     .min(0, "Fine must be zero or more"),
//   vehicleBelongsTo: Yup.string(),
//   category: Yup.string(),
//   remarks: Yup.string(),
//   cost: Yup.number()
//     .typeError("Cost must be a number")
//     .min(0, "Cost must be zero or more"),
//   purchaseCost: Yup.number()
//     .typeError("Purchase Cost must be a number")
//     .min(0, "Purchase Cost must be zero or more"),
//   purchaseFrom: Yup.string(),
//   purchaseDate: Yup.string().required("Purchase Date is required"),
//   coeCost: Yup.number()
//     .typeError("COE Cost must be a number")
//     .min(0, "COE Cost must be zero or more"),
//   coeExpiryDate: Yup.string().required("COE Expiry Date is required"),
//   driverName: Yup.string(),
//   driverContactNo: Yup.string(),
//   statusNationalityAndWPSPass: Yup.string(),
//   jobSite: Yup.string(),
//   jobNumber: Yup.string(),
//   dieselAmount: Yup.number()
//     .typeError("Diesel Amount must be a number")
//     .min(0, "Diesel Amount must be zero or more"),
//   dieselTopupAmount: Yup.number()
//     .typeError("Diesel Top-up Amount must be a number")
//     .min(0, "Diesel Top-up Amount must be zero or more"),
//   rentalDriverCost: Yup.number()
//     .typeError("Rental Driver Cost must be a number")
//     .min(0, "Rental Driver Cost must be zero or more"),
//   rentalVehicleCost: Yup.number()
//     .typeError("Rental Vehicle Cost must be a number")
//     .min(0, "Rental Vehicle Cost must be zero or more"),
//   isActive: Yup.boolean().required("Please select active status"),
// });

export const insuranceValidationSchema = Yup.object().shape({
  insuranceType: Yup.string().required("Insurance Type is required"),
  policyNo: Yup.string().required("Policy No is required"),
  insurancePeriod: Yup.string().required("Insurance Period is required"),
  startDate: Yup.string().required("Start Date is required"),
  endDate: Yup.string().required("End Date is required"),
  sumInsured: Yup.number()
    .typeError("Sum Insured must be a number")
    .required("Sum Insured is required"),
  class: Yup.string(),
  employeesList: Yup.string(),
  purpose: Yup.string(),
  abbreviation: Yup.string(),
  responsibleBy: Yup.string().required("Responsible By is required"),
  vendorName: Yup.string().required("Vendor Name is required"),
  agencyName: Yup.string().required("Agency Name is required"),
  address: Yup.string().required("Address is required"),
  contactNo: Yup.string()
    .min(8, "Contact No must be 8 digits")
    .typeError("Contact No is required")
    .required("Contact No is required")
    .matches(
      /^\d+(\.\d{1,2})?$/,
      "Contact No must contain only numeric values"
    ),
  emailID: Yup.string()
    .email("Invalid email format")
    .required("Email ID is required"),
  attachment: Yup.string(), //.required("Invalid attachment URL"),
  // status: Yup.string().required("Status is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const vehileCategoryValidationSchema = Yup.object().shape({
  categoryName: Yup.string().required("Acadamic Name is required"),
  isActive: Yup.boolean().required("Please select active status"),
});

export const vehicleInformationValidationSchema = Yup.object().shape({
  vehicleInformationList: Yup.array().of(
    Yup.object().shape({
      vehicleNumber: Yup.string().required(
        "Vehicle Number is required in vehicle information"
      ),
      companyCode: Yup.number().required(),
      vehicleName: Yup.string().required(
        "Vehicle Name is required in vehicle information"
      ),
      vehicleType: Yup.string().required(
        "Vehicle Type is required in vehicle information"
      ),
      company: Yup.string().required(
        "Company is required in vehicle information"
      ),
      department: Yup.string().required(
        "Department is required in vehicle information"
      ),
      iuLabelNumber: Yup.string(),
      // .required(
      //   "IU Label Number is required in vehicle information"
      // ),
      chassisNumber: Yup.string(),
      // .required(
      //   "Chassis Number is required in vehicle information"
      // ),
      vehicleModel: Yup.string(),
      // .required(
      //   "Vehicle Model is required in vehicle information"
      // ),
      vehicleCategory: Yup.string().required(
        "Vehicle Category is required in vehicle information"
      ),
      propellant: Yup.string(),
      // .required(
      //   "Propellant is required in vehicle information"
      // ),
      status: Yup.string(),
      // .required(
      //   "Status is required in vehicle information"
      // ),
      assetTagNo: Yup.string(),
      // .required(
      //   "Asset Tag No is required in vehicle information"
      // ),
      gpsSimNo: Yup.string(),
      // .required(
      //   "GPS Sim No is required in vehicle information"
      // ),
      requireTill: Yup.string()
        .typeError("Require Till must be a date")
        .required("Require Till is required in vehicle information"),
      registerDate: Yup.string()
        .typeError("Register Date must be a date")
        .required("Register Date is required in vehicle information"),
      fine: Yup.number()
        .integer("Fine must be an integer")
        .required("Fine is required in vehicle information")
        .typeError("Fine must be a number")
        .min(0, "Fine must be zero or more"),
      vehicleBelongsTo: Yup.string(),
      // .required(
      //   "Vehicle Belongs To is required in vehicle information"
      // ),
      category: Yup.string(),
      // .required(
      //   "Category is required in vehicle information"
      // ),
      remarks: Yup.string(),
      // .required(
      //   "Remarks is required in vehicle information"
      // ),
      cost: Yup.number()
        .integer("Cost must be an integer")
        // .required("Cost is required in vehicle information")
        // .typeError("Cost must be a number")
        .min(0, "Cost must be zero or more"),
      purchaseCost: Yup.number()
        .integer("Purchase Cost must be an integer")
        .min(0, "Purchase Cost must be zero or more"),
      // .required("Purchase Cost is required in vehicle information")
      // .typeError("Purchase Cost must be a number")
      // .min(0, "Purchase Cost must be zero or more"),
      purchaseFrom: Yup.string(),
      // .required(
      //   "Purchase From is required in vehicle information"
      // ),
      purchaseDate: Yup.string()
        .typeError("Purchase Date must be a date")
        .required("Purchase Date is required in vehicle information"),
      coeCost: Yup.number()
        .integer("COE Cost must be an integer")
        // .required("COE Cost is required in vehicle information")
        // .typeError("COE Cost must be a number")
        .min(0, "COE Cost must be zero or more"),
      coeExpiryDate: Yup.string()
        .typeError("COE Expiry Date must be a date")
        .required("COE Expiry Date is required in vehicle information"),
      driverName: Yup.string(),
      // .required(
      //   "Driver Name is required in vehicle information"
      // ),
      driverContactNo: Yup.string(),
      // .required(
      //   "Driver Contact No is required in vehicle information"
      // ),
      statusNationalityAndWPSPass: Yup.string(),
      // .required(
      //   "Status Nationality and WPS Pass is required in vehicle information"
      // ),
      jobSite: Yup.string(),
      // .required(
      //   "Job Site is required  in vehicle information"
      // ),
      jobNumber: Yup.string(),
      // .required(
      //   "Job Number is required  in vehicle information"
      // ),
      dieselAmount: Yup.number()
        .integer("Diesel Amount must be an integer")
        .required("Diesel Amount is required  in vehicle information")
        .typeError("Diesel Amount must be a number")
        .min(0, "Diesel Amount must be zero or more"),
      dieselTopupAmount: Yup.number()
        .integer("Diesel Top-up Amount must be an integer")
        .required("Diesel Top-up Amount is required  in vehicle information")
        .typeError("Diesel Top-up Amount must be a number")
        .min(0, "Diesel Top-up Amount must be zero or more"),
      rentalDriverCost: Yup.number()
        .integer("Rental Driver Cost must be an integer")
        .required("Rental Driver Cost is required  in vehicle information")
        .typeError("Rental Driver Cost must be a number")
        .min(0, "Rental Driver Cost must be zero or more"),
      rentalVehicleCost: Yup.number()
        .integer("Rental Vehicle Cost must be an integer")
        .required("Rental Vehicle Cost is required in vehicle information")
        .typeError("Rental Vehicle Cost must be a number")
        .min(0, "Rental Vehicle Cost must be zero or more"),
      // createUser: Yup.string().required(),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required("Please select active status"),
    })
  ),
  vehicleExpensesList: Yup.array().of(
    Yup.object().shape({
      expenseID: Yup.number(), //.required(),
      companyCode: Yup.number(), //.required(),
      vehicleNumber: Yup.string().required(
        "Vehicle Number is required in vehicle expenses"
      ),
      insuranceNumber: Yup.string().required(
        "Insurance Number is required  in vehicle expenses"
      ),
      insurancePeriod: Yup.string().required(
        "Insurance Period is required  in vehicle expenses"
      ),
      insuranceAmount: Yup.number()
        .integer("Insurance Amount must be an integer")
        .typeError("Insurance Amount must be a number")
        .min(0, "Insurance Amount must be zero or more")
        .required("Insurance Amount is required  in vehicle expenses"),
      insuranceVendor: Yup.string().required(
        "Insurance Vendor is required  in vehicle expenses"
      ),
      insuranceAgency: Yup.string().required(
        "Insurance Agency is required  in vehicle expenses"
      ),
      insuranceExpiryDate: Yup.string().required(
        "Insurance Expiry Date is required  in vehicle expenses"
      ),

      craneInsuranceExpiryDate: Yup.string().required(
        "Crane Insurance Expiry Date is required  in vehicle expenses"
      ),
      lorryCraneLMCertExpiryDate: Yup.string().required(
        "Lorry Crane LM Cert Expiry Date is required  in vehicle expenses"
      ),
      lgNextDueDate: Yup.string().required(
        "Lorry Crane LM Cert Expiry Date is required  in vehicle expenses"
      ),
      roadTaxDueDate: Yup.string().required(
        "Road Tax Due Date is required  in vehicle expenses"
      ),
      inspectionDueDate: Yup.string().required(
        "Inspection Due Date is required  in vehicle expenses"
      ),
      roadTaxInspectionAmount: Yup.number(), // .required("Road Tax Inspection Amount is required  in vehicle expenses"),
      roadTaxInvRef: Yup.string(), //.required("Road Tax Invoice Reference is required  in vehicle expenses"),
      ncd: Yup.string(), //.required("NCD is required  in vehicle expenses"),
      remarks: Yup.string(), //.required("Remarks is required  in vehicle expenses"),
      parkingNextDueDate: Yup.string().required(
        "Parking Next Due Date is required  in vehicle expenses"
      ),
      vpc: Yup.string(), //.required("VPC is required  in vehicle expenses"),
      vpcAmount: Yup.number()
        .integer("VPC Amount must be an integer")
        .typeError("VPC Amount must be a number")
        .min(0, "VPC Amount must be zero or more"), //.required("VPC Amount is required  in vehicle expenses"),
      vpcAddress: Yup.string(), //.required("VPC Address is required  in vehicle expenses"),
      parkingVendor: Yup.string(), //.required("Parking Vendor is required  in vehicle expenses"),
      parkingLocation: Yup.string(), //.required("Parking Location is required  in vehicle expenses"),
      parkingAmount: Yup.number()
        .integer("Parking Amount must be an integer")
        .typeError("Parking Amount must be a number")
        .min(0, "Parking Amount must be zero or more")
        .required("Parking Amount is required  in vehicle expenses"),
      parkingCouponNextDueDate: Yup.string().required(
        "Parking Coupon Next Due Date is required  in vehicle expenses"
      ),
      parkingAddress: Yup.string(), //.required("Parking Address is required  in vehicle expenses"),
      parkingPaymentMode: Yup.string(), //.required("Parking Payment Mode is required  in vehicle expenses"),
      fmtDueDate: Yup.string().required(
        "FMT Due Date is required  in vehicle expenses"
      ),
      fmtAmount: Yup.number()
        .integer("FMT Amount must be an integer")
        .typeError("FMT Amount must be a number")
        .min(0, "FMT Amount must be zero or more")
        .required("FMT Amount is required  in vehicle expenses"),
      shellCardNo: Yup.string(), //.required("Shell Card No is required  in vehicle expenses"),
      shellPIN: Yup.string(), // .required("Shell PIN is required  in vehicle expenses"),
      // createUser: Yup.string().required(),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required(
        "Please select active status in vehicle expenses"
      ),
    })
  ),
  vehicleAccidentList: Yup.array().of(
    Yup.object().shape({
      accidentID: Yup.number().required(),
      companyCode: Yup.number().required(),
      accidentDate: Yup.string().required(
        "Accident Date is Required in vehicle accidents"
      ),
      accidentLocation: Yup.string().required(
        "Accident Location is Required in vehicle accidents"
      ),
      driverName: Yup.string().required(
        "Driver Name is Required in vehicle accidents"
      ),
      driverContactNumber: Yup.string().required(
        "Driver Contact Number is Required in vehicle accidents"
      ),
      refundFromInsuranceAmount: Yup.number()
        .integer("Refund From Insurance Amount must be an integer")
        .typeError("Refund From Insurance Amount must be a number")
        .min(0, "Refund From Insurance Amount must be zero or more")
        .required(
          "Refund From Insurance Amount is Required in vehicle accidents"
        ),
      actualRepairingAmount: Yup.number()
        .integer("Actual Repairing Amount must be an integer")
        .typeError("Actual Repairing Amount must be a number")
        .min(0, "Actual Repairing Amount must be zero or more")
        .required("Actual Repairing Amount is Required in vehicle accidents"),
      vehicleNumber: Yup.string().required(
        "Vehicle Number is Required in vehicle accidents"
      ),
      // createUser: Yup.string().required(),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required(
        "Please select active status in vehicle accidents"
      ),
    })
  ),
  dieselUsageList: Yup.array().of(
    Yup.object().shape({
      dieselID: Yup.number().required(),
      companyCode: Yup.number().required(),
      invoiceNumber: Yup.string().required(
        "Invoice Number is Required in diesel usages"
      ),
      invoiceDate: Yup.string().required(
        "Invoice Date is Required in diesel usages"
      ),
      usageLitres: Yup.number()
        .integer("Usage Litres must be an integer")
        .typeError("Usage Litres must be a number")
        .min(0, "Usage Litres must be zero or more")
        .required("Usage Litres is Required in diesel usages"),
      amountInclGST: Yup.number()
        .integer("Amount Incl GST must be an integer")
        .typeError("Amount Incl GST must be a number")
        .min(0, "Amount Incl GST must be zero or more")
        .required("Amount Incl GST is Required in vehicle maintenances"),
      vehicleNumber: Yup.string().required(
        "Vehicle Number is Required in diesel usages"
      ),
      // createUser: Yup.string().required("Create User is required in diesel usages"),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required(
        "Please select active status in diesel usages"
      ),
    })
  ),
  vehicleMaintenanceList: Yup.array().of(
    Yup.object().shape({
      maintenanceID: Yup.number().required(),
      companyCode: Yup.number().required(),
      invoiceNumber: Yup.string().required(
        "Invoice Number is Required in vehicle maintenances"
      ),
      invoiceDate: Yup.string().required(
        "Invoice Date is Required in vehicle maintenances"
      ),
      dealerName: Yup.string().required(
        "Dealer Name is Required in vehicle maintenances"
      ),
      vehicleDescription: Yup.string().required(
        "Vehicle Description is Required in vehicle maintenances"
      ),
      amountInclGST: Yup.number()
        .integer("Amount Incl GST must be an integer")
        .typeError("Amount Incl GST must be a number")
        .min(0, "Amount Incl GST must be zero or more")
        .required("Amount Incl GST is Required in vehicle maintenances"),
      partServiced: Yup.string().required(
        "Part Serviced is Required in vehicle maintenances"
      ),
      maintenanceNextDueDate: Yup.string().required(
        "Maintenance Next Due Date is Required in vehicle maintenances"
      ),
      lmNextDueDate: Yup.string().required(
        "LM Next Due Date is Required in vehicle maintenances"
      ),
      vehicleNumber: Yup.string().required(
        "Vehicle Number is Required in vehicle maintenances"
      ),
      // createUser: Yup.string().required(),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required(
        "Please select active status in vehicle maintenances"
      ),
    })
  ),
  vehicleIndemnityList: Yup.array().of(
    Yup.object().shape({
      indemnityID: Yup.number().required(),
      companyCode: Yup.number().required(),
      indemnityNumber: Yup.string().required(
        "Indemnity Number is required in vehicle indemnities"
      ),
      indemnityDate: Yup.string().required(
        "Indemnity Date is required in vehicle indemnities"
      ),
      driverName: Yup.string().required(
        "Driver Name is required in vehicle indemnities"
      ),
      driverNRICFin: Yup.string().required(
        "Driver NRIC/FIN is required in vehicle indemnities"
      ),
      ltA_HDB: Yup.string().required(
        "LTA / HDB is required in vehicle indemnities"
      ),
      noticeNumber: Yup.string().required(
        "Notice Number is required in vehicle indemnities"
      ),
      vendor: Yup.string().required(
        "Vendor is required in vehicle indemnities"
      ),
      invoiceNumber: Yup.string().required(
        "Invoice Number is required in vehicle indemnities"
      ),
      amount: Yup.number()
        .integer("Amount must be an integer")
        .typeError("Amount must be a number")
        .min(0, "Amount must be zero or more")
        .required("Amount is required in vehicle indemnities"),
      incidentAddress: Yup.string().required(
        "Incident Address is required in vehicle indemnities"
      ),
      issuedBy: Yup.string().required(
        "Issued By is required in vehicle indemnities"
      ),
      designation: Yup.string().required(
        "Designation is required in vehicle indemnities"
      ),
      issuerNRIC: Yup.string().required(
        "Issuer NRIC is required in vehicle indemnities"
      ),
      debitStaffAmount: Yup.number()
        .integer("Debit Staff Amount must be an integer")
        .typeError("Debit Staff Amount must be a number")
        .min(0, "Debit Staff Amount must be zero or more")
        .required("Debit Staff Amount is required in vehicle indemnities"),
      writeOffAmount: Yup.number()
        .integer("Write-off Amount must be an integer")
        .typeError("Write-off Amount must be a number")
        .min(0, "Write-off Amount must be zero or more")
        .required("Write-off Amount is required in vehicle indemnities"),
      description: Yup.string().required(
        "Description is required in vehicle indemnities"
      ),
      vehicleNumber: Yup.string().required(
        "Vehicle Number is required in vehicle indemnities"
      ),
      // createUser: Yup.string().required(),
      // createDate: Yup.string().required(),
      // modifyUser: Yup.string().required(),
      // modifyDate: Yup.string().required(),
      isActive: Yup.boolean().required(
        "Please select active status in vehicle indemnities"
      ),
    })
  ),
});
